import { SpView } from 'src/components/SpView';
import { useCustomToast } from '@hooks/useToast';
import ResetPasswordForm from 'src/components/ResetPasswordForm';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import colors from '@styles/colors';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStackParamList } from 'src/pages';

const RequestResetPassword = () => {
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const toast = useCustomToast();
  const { t } = useTranslation();

  const submitSuccessAction = useCallback(() => {
    const navObj = {
      screenName: 'OnboardingLetsStart',
    };
    navigation.navigate('SuccessScreen', {
      title: t('email_sent'),
      msg: t('email_sent_msg'),
      withButton: true,
      withHeader: true,
      buttonText: t('continue'),
      buttonNavObject: navObj,
      headerNavObject: navObj,
    });
  }, []);

  const submitErrorAction = useCallback(() => {
    toast.show({
      description: t('email_address_error'),
      isError: true,
    });
  }, []);

  return (
    <SpView
      paddingHorizontal={19}
      paddingBottom={34}
      flex={1}
      backgroundColor={colors.white.color}>
      <ResetPasswordForm
        onSubmitSuccess={submitSuccessAction}
        onSubmitError={submitErrorAction}
      />
    </SpView>
  );
};

export default RequestResetPassword;
